export const operators = [
  { key: 'GreaterOrEquals', text: 'Greater or Equals (>=)', value: 'GreaterOrEquals' },
  { key: 'Greater', text: 'Greather (>)', value: 'Greater' },
  { key: 'Equals', text: 'Equals (=)', value: 'Equals' },
  { key: 'Less', text: 'Less (<)', value: 'Less' },
  { key: 'LessOrEquals', text: 'Less or Equals (<=)', value: 'LessOrEquals' }
];